import type { SfmcInboxMessage } from 'capacitor-sfmc-mobile-push';

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * SFMC's Inbox Messaging API only ever responds on a real device (native plugin call) — the
 * browser dev server has no way to exercise it. Shared between the notifications inbox screen
 * and the notification bell so both reflect the same state in dev; never used once
 * `Capacitor.isNativePlatform()` is true.
 */
export function buildDummyInboxMessages(now: number): SfmcInboxMessage[] {
  const hour = 60 * 60 * 1000;
  return [
    {
      id: 'dummy-1',
      title: '"Massadas" Fish Past Stew Weekend',
      body: "Celebrates one of Portugal's most comforting dishes",
      isRead: false,
      isDeleted: false,
      sentAt: now - 2 * hour,
    },
    {
      id: 'dummy-2',
      title: 'Sunset and Tennis?',
      body: 'A last-minute slot just opened. Book your match now.',
      isRead: false,
      isDeleted: false,
      customKeys: {
        deepLinkPath: '/en/upcoming-bookings/booking-detail/09c4b7dd-8f7c-446f-b741-16184d5c8b9d',
      },
      sentAt: now - 1 * DAY_MS,
    },
    {
      id: 'dummy-3',
      title: 'Perfect weather in Comporta',
      body: 'Secure your sunbed for the afternoon.',
      isRead: true,
      isDeleted: false,
      sentAt: now - 1 * DAY_MS - 2 * hour,
    },
    {
      id: 'dummy-4',
      title: 'Your Stay Is Ready, welcome',
      body: 'Early check-in confirmed. Enjoy your time with us.',
      isRead: true,
      isDeleted: false,
      sentAt: now - 9 * DAY_MS,
    },
  ];
}
